import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Beneficiary } from '@entity/beneficiary';
import { ContextService } from '@service/context.service';
import { BeneficiaryService } from '@service/beneficiary.service';

export const BeneficiaryResolve: ResolveFn<Beneficiary> = (route) => {
  return inject(BeneficiaryService).get(inject(ContextService).getMandantIdInstant(), route.params.id);
};
